import { toast as hotToast } from 'react-hot-toast';

// Create custom toast functions with consistent API
const toast = {
  success: (message, options = {}) => {
    return hotToast.success(message, {
      duration: 5000,
      ...options
    });
  },
  error: (message, options = {}) => {
    return hotToast.error(message, {
      duration: 5000,
      ...options
    });
  },
  info: (message, options = {}) => {
    return hotToast(message, {
      duration: 5000,
      icon: 'ℹ️',
      ...options
    });
  },
  warning: (message, options = {}) => {
    return hotToast(message, {
      duration: 5000,
      icon: '⚠️',
      ...options
    });
  },
  warn: (message, options = {}) => {
    return hotToast(message, {
      duration: 5000,
      icon: '⚠️',
      ...options
    });
  },
  loading: (message, options = {}) => {
    return hotToast.loading(message, {
      ...options
    });
  },
  dismiss: hotToast.dismiss,
};

export { toast };
export default toast;
